import { render, staticRenderFns } from "./FactoryLoadPortDetail.vue?vue&type=template&id=4f769dbc"
import script from "./FactoryLoadPortDetail.vue?vue&type=script&lang=js"
export * from "./FactoryLoadPortDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports